import React from 'react';
import { Header } from './Header';
import './style.css';
const Container = (props) => {
    const { conqFlagImage, children, ...headerProps } = props;
    return (React.createElement("div", { className: 'user-info' },
        React.createElement("div", { className: 'container content' },
            React.createElement("div", { className: 'conq-flag-container' },
                React.createElement("img", { src: conqFlagImage, className: 'conq-flag' })),
            React.createElement(Header, { ...headerProps }),
            React.createElement("div", { className: 'blocks-container' }, children))));
};
export { Container };
